var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcChevronRight24X24 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.646 5.81a.75.75 0 0 1 1.06 0l5.65 5.66a.75.75 0 0 1 0 1.06l-5.65 5.66a.75.75 0 1 1-1.061-1.06L14.766 12 9.645 6.87a.75.75 0 0 1 0-1.061Z",
  fill: "#0C1120"
})));
export default SvgIcChevronRight24X24;